import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const missingRevenueTrendSlice = createApi({
  reducerPath: "missingRevenueTrend",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: [
    "missingRevenueTrend",
  ],
  endpoints: (build) => ({
    getMissingRevenueTrend: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/missed_revenue/trend`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
      providesTags: (_) => ["missingRevenueTrend"],
    }),
  }),
});

export const {
  useGetMissingRevenueTrendQuery,
} = missingRevenueTrendSlice;

export const useQueryStateMissingRevenueTrend = (queryHook, args) => {
  const result = queryHook(args);
  return {
    data: result?.data?.data[0],
    isLoading: result?.isLoading,
    isFetching: result?.isFetching,
    isError: result?.isError,
    error: result?.error,
  };
};
